// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[id^="sessionList_"] .singleSession:last-child {
    border-bottom: calc(var(--bs-border-width)*2) solid rgba(var(--ws-rgb), 0.4);
    margin-bottom: 4px;
    padding-bottom: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/views/stats/style.css"],"names":[],"mappings":"AAAA;IACI,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":["[id^=\"sessionList_\"] .singleSession:last-child {\r\n    border-bottom: calc(var(--bs-border-width)*2) solid rgba(var(--ws-rgb), 0.4);\r\n    margin-bottom: 4px;\r\n    padding-bottom: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
